import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import ReleaseNotes from 'flow/components/ReleaseNotes';
import { generatePath } from 'flow/utils/router-utils';

const SettingsReleaseNotes = () => {
    const history = useHistory();
    const { extensionKey } = useParams<{
        extensionKey: ExtensionKey;
    }>();

    return (
        <ReleaseNotes
            onBack={() =>
                history.push(
                    generatePath(routes['settings.general'], { extensionKey }),
                )
            }
        />
    );
};

export default SettingsReleaseNotes;
